module.exports = __webpack_public_path__ + "img/symbol_17.ba49bb30.png";